export const REQUEST = 'AUTH_REQUEST_MAGIC_LINK_REQUEST';
export const SUCCESS = 'AUTH_REQUEST_MAGIC_LINK_SUCCESS';
export const FAILURE = 'AUTH_REQUEST_MAGIC_LINK_FAILURE';

export const fetchRequest = (email) => ({
  type: REQUEST,
  payload: { email }
});

export const fetchSuccess = (data) => ({
  type: SUCCESS,
  payload: data
});

export const fetchFailure = (error) => ({
  type: FAILURE,
  payload: error
});
